class DrawerMenu extends HTMLElement {
  constructor() {
    'use strict';
    super();

    this.el = this;
    this.mainLevel = this.el.querySelector('.drawer-menu__contents');
    this.init();
  }

  init() {
    // These toggle submenu panel
    this.firstLevelItemsWithChildren = this.el.querySelectorAll('.drawer-menu__item__input');
    this.firstLevelItemsWithChildren.forEach((input) => {
      input.addEventListener('change', this.toggleMenuItem.bind(this));
    });
    
    // These toggle subsubmenu panel
    this.secondLevelItemsWithChildren = this.el.querySelectorAll('.drawer-submenu__item__input');
    this.secondLevelItemsWithChildren.forEach((input) => {
      input.addEventListener('change', this.toggleMenuItem.bind(this));
    });

    // These handle closing of navigation
    this.closeButtons = this.el.querySelectorAll('[data-close]');
    this.closeButtons.forEach((btn) => {
      btn.addEventListener('click', this.closeAllItems.bind(this));
    });

    // Note: Drawer closing is now handled centrally in Woolman.ModalsAndDrawers.showModalOrDrawer
    // which ensures only one drawer can be open at a time

    this.overlay = this.el.querySelector('[data-overlay]');
    this.overlay.addEventListener('click', this.closeAllItems.bind(this));

    // These handle going back to previous panel
    this.secondLevelBackButtons = this.el.querySelectorAll('[data-drawer-submenu-close]');
    this.secondLevelBackButtons.forEach((button) => {
      button.addEventListener('click', this.toggleSubPanel.bind(this));
    });

    this.thirdLevelBackButtons = this.el.querySelectorAll('[data-drawer-subsubmenu-close]');
    this.thirdLevelBackButtons.forEach((button) => {
      button.addEventListener('click', this.toggleSubPanel.bind(this));
    });

    // Handle opening of specific subitem from anywhere in the theme
    this.subitemOpeners = document.querySelectorAll('[data-drawer-submenu-open]');
    this.subitemOpeners.forEach((button) => {
      button.addEventListener('click', this.toggleMenuItemFromTheme.bind(this));
    });
  }

  closeAllItems(event, skipEl, target) {
    if (!target) {
      target = this.mainLevel;
    }

    const checkboxes = target.querySelectorAll('input:checked');
    const childPanels = target.querySelectorAll('[data-menu-panel]');

    checkboxes.forEach((checkbox) => {
      if (skipEl && checkbox === skipEl) {
        return;
      }
      checkbox.checked = false;
      const accordion = checkbox.closest('[data-accordion-item]');
      if (accordion) {
        accordion.classList.remove('is-open');
        if (screen.width <= 820) {
          const parent = accordion.closest('.drawer-menu__contents');
          parent.classList.remove('pull-left');
        }
      }
    });

    childPanels.forEach((panel) => panel.classList.remove('has-open-submenu'));

    if (!skipEl) {
      this.mainLevel.classList.remove('has-open-submenu');
    }
  }

  toggleMenuItem(scope) {
    const input = scope.currentTarget || scope;
    if (!input) return;

    const level = +input.getAttribute('data-current-level');
    const target = level === 1 ? this.mainLevel : input.closest('[data-menu-panel]');
    this.closeAllItems(scope, input, target);

    const accordion = input.closest('[data-accordion-item]');
    if (!accordion) {
      return;
    }
    
    accordion.classList.toggle('is-open');
    if (accordion.classList.contains('is-open')) {
      target.classList.add('has-open-submenu');
    } else {
      target.classList.remove('has-open-submenu');
    }
  }

  toggleMenuItemFromTheme(scope) {
    let target = false;
    const button = scope.currentTarget || scope;
    const url = button.getAttribute('data-drawer-submenu-open');

    for (const input of this.firstLevelItemsWithChildren) {
      if (input.getAttribute('data-href') === url) {
        target = input;
        break;
      }
    }

    if (!target) return;

    // Close the drawer and all its children before opening a new panel
    if (this.classList.contains('is-open') && !target.checked) {
      Woolman.ModalsAndDrawers.closeModalOrDrawer(this.el.getAttribute('id'));
      this.closeAllItems();
    }

    // Get the first navigation item in the panel to focus on when the panel is opened
    const parent = target.closest('[data-accordion-item]');
    const focusTarget = parent.querySelector('[data-accordion-panel] [data-navigation-item]');

    Woolman.ModalsAndDrawers.showModalOrDrawer(this.el.getAttribute('id'), null, null, focusTarget);

    const animationFinished = () => {
      this.el.removeEventListener('transitionend', animationFinished);

      const evt = new Event('change');
      target.checked = true;
      target.dispatchEvent(evt);
    };
    this.el.addEventListener('transitionend', animationFinished);
  }

  toggleSubPanel(event) {
    const button = event.currentTarget;
    const parentAccordion = button.closest('[data-accordion-item]');

    if (parentAccordion) {
      const checkbox = parentAccordion.querySelector('input');
      if (checkbox) checkbox.checked = false;

      parentAccordion.classList.remove('is-open');
      const parentPanel = parentAccordion.closest('[data-menu-panel]');
      
      if (parentPanel) {
        parentPanel.classList.remove('has-open-submenu');
        const checkboxes = parentPanel.querySelectorAll('input:checked');
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
          const accordion = checkbox.closest('[data-accordion-item]');
          if (accordion) accordion.classList.remove('is-open');
        });
      }

      // Focus visible only when using keyboard
      const options = { focusVisible: event.pointerType === "" };

      checkbox.focus(options);
    }

    // TODO: Check if this is still needed
    // const targetSelector = button.getAttribute('data-drawer-submenu-close');
    // if (!targetSelector) {
    //   return;
    // }

    // const input = document.getElementById(targetSelector);
    // if (!input) {
    //   return;
    // }

    // input.focus();
  }
}

if (customElements.get('drawer-menu') === undefined) {
  customElements.define('drawer-menu', DrawerMenu);
}
